/**
 * Format error message from API response
 * @param {Object} error - Axios error object
 * @returns {string|Array} - Formatted error message(s). Returns array for validation errors to show multiple toasts
 */
export const formatErrorMessage = (error) => {
  if (!error.response?.data) {
    return 'An unexpected error occurred';
  }

  const errorData = error.response.data;

  // Handle validation errors
  if (errorData.error === 'validation_error' && errorData.details) {
    // Format validation error details
    const messages = errorData.details.map(detail => {
      if (detail.field) {
        return `${detail.field}: ${detail.message}`;
      }
      return detail.message;
    });
    
    // Return array of messages for multiple toasts, or single message if only one
    return messages.length === 1 ? messages[0] : messages;
  }

  // Handle duplicate application (409)
  if (errorData.error === 'Duplicate application') {
    return errorData.message || 'You already have a leave application for this period.';
  }

  if (errorData.error === 'Insufficient annual leave') {
    return (
      errorData.message ||
      'Insufficient paid leave balance. You cannot submit this application because approval would result in a negative balance.'
    );
  }

  if (errorData.error === 'CERTIFICATE_REQUIRED') {
    return errorData.message || 'A medical certificate is required for this leave type.';
  }

  if (errorData.error === 'COMPENSATION_ATTACHMENT_REQUIRED') {
    return (
      errorData.message ||
      'A manager approval screenshot or file is required for compensation leave.'
    );
  }

  if (errorData.error === 'OTHER_PAID_DOCUMENT_REQUIRED') {
    return errorData.message || 'A supporting document is required for Other Paid Leave.';
  }

  if (errorData.error === 'LEAVE_TYPE_NOT_ALLOWED') {
    return (
      errorData.message ||
      'This leave type is no longer available. Please choose another leave type.'
    );
  }

  // Handle other errors
  return errorData.error || 'An error occurred';
};

/**
 * Display error message(s) using toast
 * @param {Function} toastError - toast.error function
 * @param {string|Array} message - Error message(s) from formatErrorMessage
 */
export const showErrorMessage = (toastError, message) => {
  if (Array.isArray(message)) {
    // Show multiple toasts for validation errors
    message.forEach(msg => toastError(msg));
  } else {
    // Show single toast for other errors
    toastError(message);
  }
};

